<template>
    <v-col
      cols="12"
      md="9"
      :lg="lg"
    >
    <slot></slot>
  </v-col>
</template>

<script>
export default {
    props: {
      lg: {
        default: 9
      }
  },
  name: "Col9"
}
</script>

<style scoped>

</style>